import { combineReducers } from "@reduxjs/toolkit";
import { uploadImageReducer } from "./slices";

const uploadReducer = combineReducers({ uploadImage: uploadImageReducer });

export default uploadReducer;
